import React from 'react';

import Hospital from '../hospital';
import HospitalTable from '../hospital-table';

import ActiveHospital from '../activeHospital';
import ActiveHospitalTable from '../activeHospital-table';

import SectionHeader from '../SectionHeader';
import Infographic from '../Infographic';
import trans from '../../translations.json';

import HospitalizationMapIndex from '../hospitalizationMap/hospitalizationMapIndex';
// import ReducedData from '../../reducedData.json';
// import dict from '../../dictionary';
// var covidData = ReducedData.covidData;
// const latest = covidData[covidData.length - 1];
// const previous = covidData[covidData.length - 2];

const Hospitalizations = (props) => {
  // const stats = {
  //   cumm: [
  //     {
  //       label: trans.viewModes.total[props.lang],
  //       value: latest[dict.totaCases],
  //       difference: latest[dict.totaCases] - previous[dict.totaCases],
  //     },
  //     {
  //       label: trans.viewModes.resolved[props.lang],
  //       value: latest[dict.resolved],
  //       difference: latest[dict.resolved] - previous[dict.resolved],
  //     },
  //     {
  //       label: trans.viewModes.deaths[props.lang],
  //       value: latest[dict.deaths],
  //       difference: latest[dict.deaths] - previous[dict.deaths],
  //     },
  //   ],
  //   curr: [
  //     {
  //       label: trans.hospital.hospitalized[props.lang],
  //       value: latest[dict.patientHospitalizedCOVID19],
  //       difference:
  //         latest[dict.patientHospitalizedCOVID19] -
  //         previous[dict.patientHospitalizedCOVID19],
  //     },
  //     {
  //       label: trans.overview.icuAbbr[props.lang],
  //       value: latest[dict.patientsICUwCOVID19],
  //       difference:
  //         latest[dict.patientsICUwCOVID19] -
  //         previous[dict.patientsICUwCOVID19],
  //     },
  //     {
  //       label: trans.hospital.ventilator[props.lang],
  //       value: latest[dict.patientsICUventilatorwCOVID19],
  //       difference:
  //         latest[dict.patientsICUventilatorwCOVID19] -
  //         previous[dict.patientsICUventilatorwCOVID19],
  //     },
  //   ],
  // };
  return (
    <>
      <SectionHeader
        id="hospitalizations"
        title={trans.otp.hospitalizations}
        lastUpdated={props.lastUpdated}
        lang={props.lang}
      >
        <div className="ontario-row">
          <Infographic
            id=""
            lang={props.lang}
            defaultSelection="chart"
            width="full"
            titleDesc={{
              title: trans.hospitalMap.title,
            }}
            opts={['chart']}
            chart={<HospitalizationMapIndex lang={props.lang} />}
          />

          <Infographic
            id="InICU"
            lang={props.lang}
            titleDesc={{
              title: trans.hospital.active,
              desc: trans.hospital.activeDesc,
            }}
            bar={
              <ActiveHospital
                lang={props.lang}
                chartTitle={trans.hospital.active[props.lang]}
              />
            }
            width="full"
            table={<ActiveHospitalTable lang={props.lang} />}
          />

          <Infographic
            id="Hospital"
            lang={props.lang}
            titleDesc={{
              title: trans.hospital.title,
              desc: trans.hospital.hospitalDesc,
            }}
            width="full"
            bar={
              <Hospital
                lang={props.lang}
                chartTitle={trans.hospital.title[props.lang]}
              />
            }
            table={<HospitalTable lang={props.lang} />}
          />
        </div>
      </SectionHeader>
    </>
  );
};

export default Hospitalizations;
